import { render } from "./SaveModalCategorySearch.vue?vue&type=template&id=6cbcc912&scoped=true"
import script from "./SaveModalCategorySearch.vue?vue&type=script&lang=js"
export * from "./SaveModalCategorySearch.vue?vue&type=script&lang=js"

import "./SaveModalCategorySearch.vue?vue&type=style&index=0&id=6cbcc912&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbcc912"]])

export default __exports__